import {useMemo} from "react";
import {DANGEROUS_HTML_PATTERNS} from "../utils/Constant";

interface ISafeHTMLProps {
  content: string;
  fallbackToText?: boolean;
}

const SafeHTML: React.FC<ISafeHTMLProps> = (props) => {
  const {content, fallbackToText = true,} = props;

  const shouldFallback = useMemo(() => {
    if (!fallbackToText) {
      return false;
    }

    // Kiểm tra các pattern nguy hiểm
    return DANGEROUS_HTML_PATTERNS.some(pattern => pattern.test(content));
  }, [content, fallbackToText]);

  // Nếu phát hiện nguy hiểm, render plain text
  if (shouldFallback) {
    return (<span>{content}</span>);
  }

  // Render HTML với content gốc
  return (<div dangerouslySetInnerHTML={{__html: content}}/>);
};

export default SafeHTML;